/**
* @author XuZiYu
* @date 2019/7/2
* @time 11:22
*/
<template>
    <div class="wrapper">
        <div class="select">
            <div :class="['tab',tabIndex === 1 && 'click']" @click="changeTab(1)">
                <span>{{orderTypeOption[formData.orderType]}}</span><img src="../../assets/goods/icon_take_up.png" alt=""/>
            </div>
            <div :class="['tab',tabIndex === 2 && 'click']" @click="changeTab(2)">
                <span>{{formData.categoryName}}</span><img src="../../assets/goods/icon_take_up.png" alt=""/>
            </div>
        </div>
        <div class="select-bg" v-if="tabIndex" @click="tabIndex = ''"></div>
        <transition
                name="selectTransition"
                enter-active-class="selectIn"
                leave-active-class="selectOut"
        >
            <div class="sort-select-wrapper" v-if="tabIndex === 1">
                <ul>
                    <li v-for="(v,i) in orderTypeOption" :key="i" :class="[i === formData.orderType && 'click']" @click.stop="changeSort(i)">
                        {{v}}
                    </li>
                </ul>
            </div>
            <div class="class-select-wrapper" v-if="tabIndex === 2">
                <ul v-for="(v,i) in goodsCategoryOption" :key="i">
                    <li>
                        <h2>{{v.title}}</h2>
                    </li>
                    <li class="option-group">
                        <div v-for="(vC,iC) in v.listResult" :key="iC" :class="['option',vC.categoryId === formData.categoryId && 'click']" @click.stop="changeClass(vC)">
                            {{vC.categoryName}}
                        </div>
                    </li>
                </ul>
                <div class="pre"></div>
            </div>
        </transition>
        <van-pull-refresh
                v-model="refreshing"
                @refresh="refresh"
        >
            <van-list
                    class="list"
                    v-model="loading"
                    :finished="finished"
                    :finished-text="'没有更多了'"
                    @load="getGoodsList"
            >
                <div class="list-item" v-for="(v,i) in list" :key="i" @click="toDetail(v)">
                    <div class="image">
                        <img :src="v.imgUrl" alt="">
                        <div class="none" v-if="v.saleStatus === 2">
                            已售罄
                        </div>
                    </div>
                    <h2>{{v.name}}</h2>
                    <p>
                        <b class="icon" v-if="v.rmbPrice">¥</b><b>{{v.rmbPrice ? v.beanPrice ? `${v.rmbPrice}+` : `${v.rmbPrice}` :''}}{{v.beanPrice ? v.beanPrice: ''}}</b>{{v.beanPrice ? '斑豆' : '' }}
                    </p>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import { List, PullRefresh, Loading, Toast } from 'vant'

export default {
    name: 'index',
    data () {
        return {
            loading: false,
            refreshing: false,
            finished: false,
            tabIndex: '',
            classIndexName: '分类',
            list: [],
            current: 1,
            size: 10,
            orderTypeOption: {
                1: '默认',
                2: '销量升序',
                3: '销量降序',
                4: '价格升序',
                5: '价格降序'
            },
            formData: {
                orderType: '1',
                sourceType: 1,
                categoryId: '',
                categoryName: '分类',
                current: 1,
                size: 6
            },
            goodsCategoryOption: []
        }
    },
    components: {
        [List.name]: List,
        [PullRefresh.name]: PullRefresh,
        [Loading.name]: Loading
    },
    methods: {
        toDetail (v) {
            const appVersion = this.$jsBridge.callBackHandler('getAppVersion')
            const appType = this.$jsBridge.callBackHandler('getAppType')
            const versionList = appVersion ? appVersion.split('.') : []
            const isIos = navigator.userAgent.toLowerCase().includes('iphone')
            if (Number(appType) !== 100 && appVersion && Number(versionList.join('')) > 572 && !isIos) { // 新版本二级页面通过跳转新webview打开
                let { origin } = window.location
                // 本地IP路径
                if (origin.includes('10')) origin = 'https://dev.ctl.chelizitech.com'
                const url = `${origin}/ui/shops/detail?id=${v.id}&sourceType=${this.$route.query.sourceType}`
                this.$jsBridge.callBackHandler('pushSecondaryPage', {
                    secondaryUrl: url
                })
                return
            }
            this.$router.push({
                name: 'detail',
                query: {
                    id: v.id,
                    sourceType: this.$route.query.sourceType
                }
            })
        },
        // 切换标签
        changeTab (v) {
            this.tabIndex = v === this.tabIndex ? '' : v
        },
        // 选择排序
        changeSort (v) {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.formData.orderType = v
            this.formData.current = 1
            this.getGoodsList(true)
            this.tabIndex = ''
        },
        // 选择类型
        changeClass (v) {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.formData.categoryId = v.categoryId === this.formData.categoryId ? '' : v.categoryId
            this.formData.categoryName = this.formData.categoryName === v.categoryName ? '分类' : v.categoryName
            this.formData.current = 1
            this.getGoodsList(true)
            this.tabIndex = ''
        },
        // 获取商品分类
        getGoodsCategory () {
            this.$api.getGoodsCategory().then(res => {
                this.goodsCategoryOption = res.result
            })
        },
        // 获取商品列表
        getGoodsList (v) {
            let data = Object.assign({}, this.formData)
            this.$api.getGoodsList(data).then(res => {
                this.loading = false
                setTimeout(() => {
                    this.refreshing = false
                    Toast.clear()
                }, 500)
                if (res.status) {
                    let list = res.result.records
                    v ? this.list = list : this.list.push(...list)
                    this.formData.current++
                    this.finished = list.length < data.size
                } else {
                    setTimeout(() => {
                        Toast.fail(res.message)
                    }, 500)
                    this.finished = true
                }
            })
        },
        // 上拉刷新
        refresh () {
            this.formData.current = 1
            this.getGoodsList(true)
        }
    },
    mounted () {
        Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
        this.getGoodsCategory()

        // 兼容wk跳转刷新
        this.$jsBridge.callBackHandler('shouldReloadWhenGoBack')
    },
    created () {
        let appType = this.$jsBridge.callBackHandler('getAppType')

        if (Number(appType) === 100) {
            // 切换app标题
            document.title = '斑斑商城'
            this.$jsBridge.callBackHandler('changeTitle', { title: '斑斑商城' })
        }

        this.formData.sourceType = this.$route.query.sourceType
    }
}
</script>
<style scoped lang="scss">
    .wrapper {
        overflow: hidden;
    }

    .class-select-wrapper {
        position: fixed;
        top: 40px;
        width: 100%;
        z-index: 2;
        padding-bottom: 25px;

        .pre {
            height: 20px;
            width: 100%;
            background: #ffffff;
        }

        ul {
            background: #ffffff;
            padding: 20px 15px 0;
            list-style-type: none;

            h2 {
                line-height: 1;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
            }

            .option {
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 105px;
                height: 24px;
                margin-top: 15px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;
                margin-right: 15px;
                border: 1px solid rgba(204, 204, 204, 1);
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
            }

            .click {
                background: #53CB85;
                color: #ffffff;
                border-color: #53CB85;
            }

            .option:nth-child(3n) {
                margin-right: 0;
            }

            .option-group {
                display: flex;
                flex-wrap: wrap;
            }
        }
    }

    .select-bg {
        position: fixed;
        top: 45px;
        bottom: 0;
        width: 100%;
        z-index: 2;
        background: rgba(0, 0, 0, 0.4);
    }

    .sort-select-wrapper {
        position: fixed;
        top: 40px;
        z-index: 2;
        width: 100%;

        ul {
            background: #ffffff;
            padding: 10px 0;
            list-style-type: none;

            li {
                font-size: 14px;
                padding: 10px 15px;
                font-weight: 400;
                color: #333333;
                line-height: 1;
            }

            .click {
                color: #53CB85;
                background: url("../../assets/public/icon_choice@2x.png") no-repeat right 15px center;
                background-size: 22px;
            }
        }
    }

    .select {
        position: fixed;
        width: 100%;
        display: flex;
        z-index: 3;
        flex-wrap: wrap;
        background-color: #FFFFFF;

        .tab {
            flex: 1;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            padding: 10px 0;
        }

        img {
            margin-left: 5px;
            width: 12px;
            transition: .5s;
        }

        .click {
            img {
                transform: rotate(180deg);
            }
        }
    }

    .van-pull-refresh {
        background: #F5F5F5;
    }

    .list {
        background: #F5F5F5;
        min-height: calc(100vh - 16vw);
        margin-top: 45px;
        padding: 15px 15px 0;

        .list-item {
            background: #ffffff;
            border-radius: 5px;
            overflow: hidden;
            display: inline-block;
            vertical-align: top;
            width: 165px;
            margin: 0 0 20px;

            &.list-item:nth-child(2n) {
                margin-left: 15px;
            }
        }

        .image {
            position: relative;
            width: 165px;
            height: 165px;
            overflow: hidden;

            img {
                width: 165px;
                height: 165px;
                object-fit: cover;
            }

            .none {
                position: absolute;
                right: 12px;
                bottom: 20px;
                background: red;
                border-radius: 100%;
                height: 45px;
                width: 45px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-size: 14px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
            }
        }

        h2 {
            padding: 0 10px;
            margin-top: 12.5px;
            height: 35px;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-size: 13px;
            word-break: break-all;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #333333;
        }

        p {
            padding: 0 10px 10px;
            margin-top: 10px;
            font-size: 13px;
            line-height: 1;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #666666;

            b {
                font-size: 18px;
                font-style: normal;
                color: #FF5050;
            }

            .icon {
                font-size: 12px;
            }
        }
    }

    .selectIn {
        animation: selectIn .2s linear;
    }

    .selectOut {
        animation: selectOut .2s linear;
    }

    @keyframes selectIn {
        0% {
            transform: translateY(-200px)
        }
        100% {
            transform: translateY(0)
        }
    }

    @keyframes selectOut {
        0% {
            transform: translateY(0)
        }
        100% {
            transform: translateY(-200px)
        }
    }
</style>
